import PropTypes from 'prop-types';
import { useState, useEffect } from 'react';

import VerificationDocuments from '../../common/verification-documents/VerificationDocuments';
import Button from '../../common/button/Button';

import { ReactComponent as Verified } from '../../../resources/icons/verified.svg';
import { ReactComponent as NotVerified } from '../../../resources/icons/not-verified.svg';

import './verification.scss';

const Verification = ({ userVerification, uploadVerificationDocument, deleteVerificationDocument, addBrokerRole }) => {
  const [screenToDisplay, setScreenToDisplay] = useState('general');
  const [brokerCompany, setBrokerCompany] = useState(false);

  useEffect(() => {
    setBrokerCompany(userVerification?.brokerCompany ? true : false);
  }, [setBrokerCompany, userVerification]);

  return (
    <section className="verification">
      <section className="verification__available-roles">
        <h1>Available Roles</h1>
        <div className="verification__role-supplier" onClick={() => setScreenToDisplay('general')}>
          <p>Supplier</p>
          {userVerification?.generalVerification ? <Verified /> : <NotVerified />}
        </div>
        <div className="verification__role-buyer" onClick={() => setScreenToDisplay('general')}>
          <p>Buyer</p>
          {userVerification?.generalVerification ? <Verified /> : <NotVerified />}
        </div>
        <div
          className="verification__role-broker"
          onClick={() => {
            setScreenToDisplay('broker');
          }}
        >
          <p>Broker</p>
          {brokerCompany && (userVerification?.brokerVerification ? <Verified /> : <NotVerified />)}
        </div>
      </section>

      {screenToDisplay === 'general' && (
        <section className="verification__body">
          <h2>Supplier Verification Documents</h2>
          <section className="verification__card">
            <VerificationDocuments
              verification={{ documents: userVerification?.generalDocumentSubjects }}
              uploadVerificationDocument={uploadVerificationDocument}
              deleteVerificationDocument={deleteVerificationDocument}
              verificationType={'general verification'}
            />
          </section>
        </section>
      )}

      {screenToDisplay === 'broker' && brokerCompany && (
        <section className="verification__body">
          <h2>Broker Verification Documents</h2>
          <section className="verification__card">
            <VerificationDocuments
              verification={{ documents: userVerification?.brokerDocumentSubjects }}
              uploadVerificationDocument={uploadVerificationDocument}
              deleteVerificationDocument={deleteVerificationDocument}
              verificationType={'broker verification'}
            />
          </section>
        </section>
      )}

      {screenToDisplay === 'broker' && !brokerCompany && (
        <section className="verification__body">
          <h2>Would you like to apply to be a broker on this platform?</h2>
          <section className="verification__card">
            <div>
              <Button type="submit" onClick={() => addBrokerRole()}>
                Apply
              </Button>
            </div>
          </section>
        </section>
      )}
    </section>
  );
};

Verification.propTypes = {
  verification: PropTypes.shape({}),
  uploadVerificationDocument: PropTypes.func.isRequired,
  deleteVerificationDocument: PropTypes.func.isRequired,
  addBrokerRole: PropTypes.func.isRequired,
};

Verification.defaultProps = {
  verification: undefined,
};

export default Verification;
